import React, { useRef, useState } from 'react';
import Styles from './PartiuGpFaq.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import Accordion from '@/components/atoms/Accordion';

const faqs = [
  {
    pergunta: 'O que é a Promoção Partiu GP da Inglaterra com Santander?',
    resposta:
      '<p>É uma promoção da Santander Financiamentos que dá a você a chance de concorrer a uma experiência de viagem para Silverstone, na Inglaterra, para viver de perto a FÓRMULA 1 PIRELLI BRITISH GRAND PRIX 2027™.</p>' +
      '<p>Ao contratar um financiamento que participe da promoção e cumprir as demais condições previstas no regulamento, você recebe Número(s) da Sorte para concorrer.</p>',
  },
  {
    pergunta: 'Quem pode participar?',
    resposta:
      '<p>Podem participar pessoas que:</p>' +
      '<ul>' +
      '<li>Tenham 18 anos ou mais, sejam legalmente capazes, residentes e domiciliadas no Brasil e tenham CPF ativo;</li>' +
      '<li>Contratem presencialmente um financiamento (CDC Auto ou Moto) participante da promoção, em um parceiro credenciado Santander, entre 01/10 e 30/11/2026;</li>' +
      '<li>Confirmem sua participação na promoção até 31/12/2026;</li>' +
      '<li>Mantenham o contrato de financiamento ativo e adimplente e cumpram as demais condições previstas no Regulamento.</li>' +
      '</ul>',
  },
  {
    pergunta: 'Como faço para participar?',
    resposta:
      '<p>É simples:</p>' +
      '<ul>' +
      '<li>Contrate presencialmente um financiamento de carro ou moto que participe da promoção, em um parceiro credenciado Santander, entre 01/10 e 30/11/2026;</li>' +
      '<li>Confirme sua participação durante a contratação ou, caso não faça nesse momento, posteriormente pela Área do Cliente, até 31/12/2026;</li>' +
      '<li>Mantenha o contrato de financiamento ativo, com os pagamentos em dia, e cumpra as demais condições previstas no Regulamento.</li>' +
      '</ul>' +
      '<p>Pronto! Cumprindo essas condições, você recebe seu Número da Sorte para concorrer.</p>',
  },
  {
    pergunta: 'Fiz o financiamento. Já estou participando?',
    resposta:
      '<p>Ainda não necessariamente. Além de contratar um financiamento que participe da promoção, você precisa confirmar sua participação e cumprir as demais condições, incluindo manter o contrato ativo e com os pagamentos em dia.</p>' +
      '<p>Se não confirmar durante a contratação, poderá fazer isso posteriormente pela Área do Cliente, até 31/12/2026.</p>',
  },
  {
    pergunta: 'Até quando posso confirmar minha participação?',
    resposta:
      '<p>Você poderá confirmar sua participação até 31/12/2026.</p>' +
      '<p>Se não fizer isso durante a contratação do financiamento, poderá confirmar posteriormente pela Área do Cliente até essa data.</p>' +
      '<p>Após 31/12/2026, não será mais possível participar da promoção.</p>',
  },
  {
    pergunta: 'Quantos Números da Sorte posso receber?',
    resposta:
      '<p>Cada financiamento que participe da promoção gera 1 Número da Sorte.</p>' +
      '<p>Além disso, você poderá receber até 2 Números da Sorte extras durante toda a promoção, independentemente da quantidade de financiamentos contratados:</p>' +
      '<ul>' +
      '<li>+1 se contratar um Seguro Prestamista que cumpra as condições da promoção junto com o financiamento;</li>' +
      '<li>+1 se for correntista Santander ativo e cumprir as condições da promoção.</li>' +
      '</ul>' +
      '<p><strong>Importante:</strong> esses dois Números da Sorte extras são concedidos uma única vez durante toda a promoção, e não a cada financiamento contratado.</p>',
  },
  {
    pergunta:
      'Preciso contratar o Seguro Prestamista ou ser correntista Santander para participar?',
    resposta:
      '<p>Não. Você não precisa contratar o Seguro Prestamista nem ter uma conta Santander ativa para participar da promoção.</p>' +
      '<p>Essas condições servem apenas para que você possa receber Números da Sorte extras, desde que tenha um financiamento que participe da promoção e cumpra as demais condições.</p>',
  },
  {
    pergunta:
      'Contratei o Seguro Prestamista no Santander depois do financiamento. Ganho um Número da Sorte extra?',
    resposta:
      '<p>Não. Para receber esse Número da Sorte extra, o Seguro Prestamista precisa ser contratado junto com o financiamento.</p>',
  },
  {
    pergunta:
      'Tenho mais de um financiamento que participa da promoção. Ganho mais Números da Sorte?',
    resposta:
      '<p>Sim. Cada financiamento participante da promoção gera 1 Número da Sorte.</p>' +
      '<p>Por exemplo: se você tiver dois financiamentos que cumpram as condições da promoção, receberá 1 Número da Sorte para cada um.</p>' +
      '<p>Já os Números da Sorte extras por Seguro Prestamista e por ser correntista ativo Santander são concedidos uma única vez durante toda a promoção, e não a cada financiamento.</p>',
  },
  {
    pergunta: 'Posso escolher ou trocar meu Número da Sorte?',
    resposta:
      '<p>Não. Os Números da Sorte são gerados e distribuídos de forma aleatória, seguindo as regras da promoção.</p>',
  },
  {
    pergunta: 'Qual é o prêmio da promoção?',
    resposta:
      '<p>O prêmio é uma viagem para o ganhador e 1 acompanhante viverem uma experiência de Fórmula 1 em Silverstone, na Inglaterra, em 2027.</p>' +
      '<p>A experiência inclui a FORMULA 1 PIRELLI BRITISH GRAND PRIX 2027™, além de momentos especiais em Londres.</p>' +
      '<p>Também estão incluídos passagens aéreas, hospedagem, traslados e os demais itens descritos no regulamento.</p>' +
      '<p><strong>Importante:</strong> gastos que não estejam previstos no regulamento não fazem parte do prêmio e ficam por conta do ganhador e de seu acompanhante.</p>' +
      '<p>Consulte o regulamento para conferir tudo o que está incluído na viagem.</p>',
  },
  {
    pergunta: 'Posso escolher a data da viagem, o voo, o hotel ou os assentos no GP?',
    resposta:
      '<p>Não. A data da viagem, os voos, o hotel, os transportes e os assentos no GP serão definidos pela organização da promoção. O ganhador deverá viajar nas datas e condições informadas pela organização.</p>',
  },
  {
    pergunta: 'Preciso ter passaporte e outros documentos para viajar?',
    resposta:
      '<p>Sim. O ganhador e seu acompanhante deverão ter passaporte válido e todos os demais documentos exigidos para realizar a viagem e entrar na Inglaterra.</p>' +
      '<p>É responsabilidade de cada viajante providenciar e manter esses documentos válidos dentro dos prazos necessários.</p>',
  },
  {
    pergunta: 'Posso levar um acompanhante?',
    resposta:
      '<p>Sim. O prêmio inclui a viagem do ganhador e de 1 acompanhante maior de 18 anos. O acompanhante também deverá cumprir as condições necessárias para realizar a viagem.</p>',
  },
  {
    pergunta: 'Posso levar mais pessoas pagando por conta própria?',
    resposta:
      '<p>Não. A viagem da promoção será realizada somente pelo ganhador e pelo acompanhante indicado.</p>',
  },
  {
    pergunta: 'Se eu ganhar e não puder viajar, posso passar a viagem para outra pessoa?',
    resposta:
      '<p>Em alguns casos, sim. Se você não puder viajar, a organização da promoção poderá permitir que outra pessoa maior de 18 anos viaje no seu lugar, desde que ainda haja tempo para fazer os ajustes necessários.</p>' +
      '<p>A pessoa indicada deverá cumprir as condições da promoção e viajar com o acompanhante que você indicou originalmente.</p>' +
      '<p>Se essa troca for autorizada, você terá até 3 dias corridos, contados a partir do momento em que a equipe da promoção conseguir falar com você, para indicar a pessoa que viajará no seu lugar.</p>' +
      '<p>A autorização será analisada caso a caso. Mesmo que outra pessoa faça a viagem, você continuará sendo o ganhador da promoção.</p>',
  },
  {
    pergunta: 'Posso trocar o prêmio por dinheiro?',
    resposta: '<p>Não. O prêmio não pode ser trocado por dinheiro.</p>',
  },
  {
    pergunta: 'Quando será o sorteio e como ele funciona?',
    resposta:
      '<p>O resultado da Loteria Federal de 03/02/2027 será usado como base para definir o Número da Sorte vencedor.</p>' +
      '<p>A identificação do possível ganhador será realizada em 11/02/2027, às 14h, seguindo as regras da promoção.</p>' +
      '<p>Se não houver sorteio da Loteria Federal em 03/02/2027, será considerada a próxima data em que houver sorteio da Loteria Federal.</p>' +
      '<p>Ter um Número da Sorte dá a você a chance de concorrer, mas não garante que você será o ganhador.</p>',
  },
  {
    pergunta: 'Como vou saber se ganhei?',
    resposta:
      '<p>Se você for identificado como possível ganhador, a equipe da promoção entrará em contato usando os dados informados na contratação do financiamento, como telefone, WhatsApp ou e-mail.</p>' +
      '<p>Por isso, mantenha seus dados atualizados e fique atento a esses canais.</p>' +
      '<p>O resultado também será divulgado nesta página.</p>',
  },
  {
    pergunta: 'Se eu for um possível ganhador, preciso enviar documentos?',
    resposta:
      '<p>Sim. Se você for identificado como possível ganhador, a equipe da promoção solicitará os documentos necessários para confirmar se todas as condições foram cumpridas.</p>' +
      '<p>Você terá até 3 dias corridos após o contato efetivo da equipe da promoção para enviar os documentos solicitados.</p>' +
      '<p>Fique atento ao prazo: se você não responder ou não enviar os documentos necessários dentro desse período, poderá perder o direito ao prêmio.</p>' +
      '<p>Consulte o regulamento para conferir os documentos e demais condições.</p>',
  },
];

function PartiuGpFaq() {
  const accRefs = useRef(faqs.map(() => React.createRef()));
  const [visibleCount, setVisibleCount] = useState(4);

  const allVisible = visibleCount >= faqs.length;

  const handleToggle = () => {
    setVisibleCount((v) => (allVisible ? 4 : Math.min(v + 4, faqs.length)));
  };

  const handleAccChange = (index, open) => {
    if (!open) return;
    accRefs.current.forEach((ref, i) => {
      if (i !== index && ref.current) {
        ref.current.close();
      }
    });
  };

  return (
    <section id="partiu-gp-faq">
      <ContainerHome24>
        <div className="faq-wrapper">
          <h2 className="faq-titulo">Dúvidas frequentes</h2>
          <div className="faq-lista">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="faq-item"
                style={index >= visibleCount ? { display: 'none' } : undefined}
              >
                <Accordion
                  title={faq.pergunta}
                  startOpen={index === 0}
                  accordionRef={accRefs.current[index]}
                  onChange={(open) => handleAccChange(index, open)}
                >
                  <div dangerouslySetInnerHTML={{ __html: faq.resposta }} />
                </Accordion>
              </div>
            ))}

            {faqs.length > 4 && (
              <button
                type="button"
                className="faq-toggle"
                onClick={handleToggle}
                aria-expanded={allVisible}
              >
                {allVisible ? 'Ver menos' : 'Ver mais'}
              </button>
            )}
          </div>
        </div>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default PartiuGpFaq;
